import { z } from 'zod';

import { schemaBuckets } from './discriminatedUnions/buckets';
import { schemaSystemMails } from './discriminatedUnions/systemMails';

export const schemaSystemVariable = z.discriminatedUnion('type', [schemaSystemMails, schemaBuckets]);

export type Schema_SystemVariable = z.infer<typeof schemaSystemVariable>;

export type Schema_SystemMails = z.infer<typeof schemaSystemMails>;
export type Schema_Buckets = z.infer<typeof schemaBuckets>;
